export const STEPS = {
  MAIN: 'MAIN',
  SOURCE_LIST: 'SOURCE_LIST',
  SOURCE_INSTRUMENTS: 'SOURCE_INSTRUMENTS',
  PORTFOLIO: 'PORTFOLIO',
  FILTERS: 'FILTERS',
};

export const SOURCES = {
  FAVOURITE_LIST: 'FavouriteList',
  MUSTER_DEPOT: 'MusterDepot',
  PORTFOLIO: 'Portfolio',
};

export const ACTIONS = {
  SET_STEP: 'SET_STEP',
  SELECT_SOURCE: 'SELECT_SOURCE',
  SELECT_SOURCE_ITEM: 'SELECT_SOURCE_ITEM',
  CONFIRM_ASSETS_SELECTION: 'CONFIRM_ASSETS_SELECTION',
  TOGGLE_SELECTED_ASSET: 'TOGGLE_SELECTED_ASSET',
  SELECT_ALL_ASSETS: 'SELECT_ALL_ASSETS',
  TOGGLE_ASSET: 'TOGGLE_ASSET',
  SET_ACTIVE_ASSETS: 'SET_ACTIVE_ASSETS',
  GO_BACK: 'GO_BACK',
};
